var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bonus-search',{on:{"doSearch":_vm.doSearch}}),_c('bonus-list',{ref:"refBonusTables",attrs:{"search-condition":_vm.searchCondition,"edit-group":_vm.calcPermission()},on:{"editBonus":_vm.editBonus,"editBill":_vm.editBill}}),_c('BonusEdit',{attrs:{"id":_vm.currentId,"visible":_vm.dialogVisible},on:{"close":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }